import { tokens } from "@manifesthhqinc/ui-library";
import styled, { css } from "styled-components";

const formDescriptionStyles = css`
  margin-top: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.75;
`;

export const MainContainerDiv = styled.div`
  background: #f8f8f8;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  padding-bottom: 24px;
  padding-right: 8px;
  overflow: hidden;
  position: relative;
  .form-description {
    ${formDescriptionStyles};
    text-align: center;
    padding-left: 8px;
    padding-right: 8px;
  }

  .form-description-with-vector {
    font-size: 14px;
    line-height: 1.75;
    text-align: center;
    padding-left: 8px;
    padding-right: 8px;
  }

  .form-description-start {
    ${formDescriptionStyles};
    text-align: left;
    padding-right: 14px;
  }
`;

export const MainContainerModalOverlay = styled.div`
  position: absolute;
  background: ${tokens.color.surface.popup.background};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10001;
`;

export const Main = styled.div`
  display: flex;
  width: 100vw;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100dvh;

  @media screen and (min-width: 768px) {
    width: 360px;
    height: 100dvh;
    overflow: hidden;
    max-height: 645px;
    border-radius: 8px;
  }
`;

export const Overlay = styled.div<{ $isLoading: boolean }>`
  width: 100vw;
  height: 100dvh;
  background: rgba (255, 255, 255, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &:before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(22, 22, 22, 0.75);
  }
  ${(props) =>
    props.$isLoading &&
    `
    div{
    background:none;}`}
`;
